const comments = [
  {
    name: '爱漫画的小明',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20chibi%20anime%20character%20avatar%2C%20warm%20orange%20hair%2C%20big%20eyes%2C%20friendly%20smile%2C%20simple%20style%2C%20clean%20white%20background&width=100&height=100&seq=avatar-01&orientation=squarish',
    text: '太好用了！下拉式阅读真的是看漫画神器，追《我独自升级》一口气看了50话，完全停不下来。',
    date: '2天前',
    likes: 128,
  },
  {
    name: '二次元少女酱',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20chibi%20anime%20girl%20avatar%20with%20pink%20hair%2C%20sparkling%20eyes%2C%20sweet%20smile%2C%20simple%20kawaii%20style%2C%20clean%20white%20background&width=100&height=100&seq=avatar-02&orientation=squarish',
    text: '终于找到一个不用注册就能免费看漫画的网站了，资源超级全，日漫韩漫都有，爱了爱了！',
    date: '3天前',
    likes: 96,
  },
  {
    name: '追更狂魔',
    avatar: 'https://readdy.ai/api/search-image?query=Cool%20chibi%20anime%20boy%20character%20avatar%20with%20dark%20hair%2C%20confident%20expression%2C%20simple%20style%2C%20clean%20white%20background&width=100&height=100&seq=avatar-03&orientation=squarish',
    text: '更新速度真的快，和韩国那边基本同步，每天都能看到最新话，追更体验满分！',
    date: '5天前',
    likes: 75,
  },
  {
    name: '漫画书虫',
    avatar: 'https://readdy.ai/api/search-image?query=Cute%20chibi%20anime%20character%20with%20glasses%2C%20bookworm%20style%2C%20warm%20brown%20hair%2C%20friendly%20smile%2C%20simple%20style%2C%20clean%20white%20background&width=100&height=100&seq=avatar-04&orientation=squarish',
    text: '喜欢这里的分类系统，找漫画太方便了。恋爱甜宠专区是我的最爱，推荐了很多好看的韩漫。',
    date: '1周前',
    likes: 62,
  },
  {
    name: '深夜追番人',
    avatar: 'https://readdy.ai/api/search-image?query=Sleepy%20chibi%20anime%20character%20with%20purple%20hair%2C%20night%20owl%20style%2C%20simple%20cute%20style%2C%20clean%20white%20background&width=100&height=100&seq=avatar-05&orientation=squarish',
    text: '每天晚上必刷歪歪漫画网，国漫专区的质量也越来越高了，《镇魂街》真的太好看了！',
    date: '1周前',
    likes: 51,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 mb-3">读者评价</h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">来自真实读者的使用反馈，听听他们怎么说歪歪漫画网</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {comments.map((comment) => (
            <div key={comment.name} className="bg-background-50 rounded-lg p-5 border border-background-200/70">
              <div className="flex items-center gap-3 mb-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                />
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.text}</p>
              <div className="flex items-center gap-1 text-accent-500 text-sm">
                <i className="ri-heart-fill"></i>
                <span className="text-xs font-medium">{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}